import { render, staticRenderFns } from "./MerchantManagement.vue?vue&type=template&id=4f447c7b&scoped=true&"
import script from "./MerchantManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f447c7b",
  null
  
)

export default component.exports